import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from './Common/Basic';
import { iconTypes, ProjectIcons } from './FontIcons';

const CenteredContents = styled(Box)`
  text-align: center;
`;

const ErrorIcon = styled.i`
  color: #ffc8cf;
`;

const RelayError = ({ error, retry }) => (
  <Flex>
    <CenteredContents small={12}>
      <ProjectIcons type={iconTypes.ALERT} color="#FE5E5E" />
      <ErrorIcon className="wpi-4x wpi-attention" />
      {error ? (
        <p>
          Error: {error.statusText} ({error.status})
        </p>
      ) : null}
      {retry ? (
        <p>
          <a onClick={() => retry()}> Retry </a>
        </p>
      ) : null}
    </CenteredContents>
  </Flex>
);

export default RelayError;
